"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var autosize = require("autosize");
var form_1 = require("../../modules/form");
require("inputmask/dist/inputmask/jquery.inputmask");
require("inputmask");
var checkoutForm;
var checkoutPageIndex = /** @class */ (function () {
    function checkoutPageIndex() {
        this.$cardTextMob = null;
        this.$textClone = null;
        this.$cardText = null;
        this.$fontTypeInput = null;
        this.$countrySelect = null;
        this.$addressInput = null;
        this.$postCodeInput = null;
        this.$nameInput = null;
        this.$cardTextMob = $('#text-mob');
        this.$textClone = $('#clone');
        this.$cardText = $('.js-card-text');
        this.$fontTypeInput = $('.js-font-type');
        this.$countrySelect = $('.js-country-select');
        this.$addressInput = $('.js-address');
        this.$postCodeInput = $('.js-post-code');
        this.$nameInput = $('.js-name');
        this.toggleCardFonts();
        this.handleTextHeightMob();
        this.handleTextHeight();
        this.updatePostCodePlaceholder();
        this.copyAndLimitInputs();
        this.validateForm();
    }
    checkoutPageIndex.getInstance = function () {
        return new checkoutPageIndex();
    };
    checkoutPageIndex.prototype.toggleCardFonts = function () {
        var $fontTypes = this.$fontTypeInput, $cardText = this.$cardText;
        $fontTypes.on('change', function () {
            var font = 'font' + $(this).val();
            $cardText.removeClass('font1 font2 font3 font4');
            $cardText.addClass(font);
            $cardText.trigger('input');
            autosize.update($cardText);
        });
    };
    checkoutPageIndex.prototype.handleTextHeightMob = function () {
        var $cardTextMob = this.$cardTextMob, $clone = this.$textClone, $cardText = this.$cardText;
        autosize($cardTextMob);
        autosize($clone);
        $cardTextMob.on('input', function () {
            var $this = $(this);
            $clone.val($this.val());
            $cardText.val($this.val());
            autosize.update($clone);
            if ($clone.height() > 320) {
                while ($clone.height() > 320) {
                    $this.val($this.val().toString().slice(0, -1));
                    $clone.val($this.val());
                    $cardText.val($this.val());
                    autosize.update($clone);
                    autosize.update($cardTextMob);
                }
            }
        });
    };
    checkoutPageIndex.prototype.handleTextHeight = function () {
        var $cardText = this.$cardText, $cardTextMob = this.$cardTextMob, $fontSizeInput = $cardText.parents('form').find('input[name=font_size]'), $fontSizeMobInput = $cardTextMob.parents('form').find('input[name=font_size]');
        autosize($cardText);
        $cardText.on('input', function () {
            var $this = $(this);
            if ($this.val().toString().length == 0) {
                $this.removeClass('small');
                $fontSizeInput.val('');
                $fontSizeMobInput.val('');
            }
            if ($this.height() > 320) {
                while ($this.height() > 320) {
                    $this.val($this.val().toString().slice(0, -1));
                    autosize.update($cardText);
                }
                $this.addClass('small');
                $fontSizeInput.val('small');
                $fontSizeMobInput.val('small');
                $(this).next().addClass('show-msg');
            }
            else if ($this.height() < 120) {
                $this.removeClass('small');
                $fontSizeInput.val('');
                $fontSizeMobInput.val('');
            }
            else {
                $(this).next().removeClass('show-msg');
            }
            $cardTextMob.val($this.val());
        });
    };
    checkoutPageIndex.prototype.updatePostCodePlaceholder = function () {
        var $select = this.$countrySelect, index = null;
        updatePlaceholder();
        $select.on('change', function () {
            updatePlaceholder();
        });
        function updatePlaceholder() {
            if ($(window).width() > 767) {
                index = 1;
            }
            else {
                index = 0;
            }
            var $postCode = $select.parents('form').find('.js-post-code'), $selectedOption = $($select.find('option:selected').get(index)), placeholder = $selectedOption.attr('data-placeholder-country'), defaultPlaceholder = $postCode.data('placeholderOther');
            $postCode.val('');
            if ($selectedOption.val() == 'Latvija') {
                $postCode.attr('placeholder', placeholder);
                $postCode.inputmask('LV-9999', { 'placeholder': 'LV-XXXX' });
            }
            else if (placeholder) {
                $postCode.attr('placeholder', placeholder);
                $postCode.inputmask('remove');
            }
            else {
                $postCode.attr('placeholder', defaultPlaceholder);
                $postCode.inputmask('remove');
            }
        }
    };
    checkoutPageIndex.prototype.copyAndLimitInputs = function () {
        var $name = this.$nameInput, $address = this.$addressInput, $country = this.$countrySelect, $postCode = this.$postCodeInput, $fonts = this.$fontTypeInput;
        $fonts.on('change', function () {
            $('.js-mobile-font').val($(this).val());
        });
        $name.on('input', function () {
            $name.not($(this)).val(sliceVal($(this).val(), 32));
        });
        $address.on('input', function () {
            $address.not($(this)).val(sliceVal($(this).val(), 70));
        });
        $country.on('change', function () {
            $country.not($(this)).val($(this).val());
        });
        $postCode.on('input', function () {
            $postCode.not($(this)).val(sliceVal($(this).val(), 12));
        });
        function sliceVal(val, maxChars) {
            var string = val.toString();
            while (string.length > maxChars) {
                string = string.slice(0, -1);
            }
            return string;
        }
    };
    checkoutPageIndex.prototype.validateForm = function () {
        var $name = this.$nameInput, $address = this.$addressInput, $country = this.$countrySelect, $postCode = this.$postCodeInput, $cardText = this.$cardText;
        $name.on('input', function () {
            checkoutForm.clearErrors($name.closest('.field'));
        });
        $address.on('input', function () {
            checkoutForm.clearErrors($address.closest('.field'));
        });
        $country.on('change', function () {
            checkoutForm.clearErrors($country.closest('.field'));
        });
        $postCode.on('input', function () {
            checkoutForm.clearErrors($postCode.closest('.field'));
        });
        $cardText.on('input', function () {
            checkoutForm.clearErrors($cardText.closest('.field'));
        });
        var $requestForm = $('.js-checkout-request-form'), $successUrl = $requestForm.data('url');
        checkoutForm = new form_1.Form($requestForm, function (response) {
            if (response.status === 'ok') {
                window.location.href = $successUrl;
            }
            if (response.status === 'card-missing') {
                window.location.href = response.shopUrl;
            }
        });
    };
    return checkoutPageIndex;
}());
exports.default = checkoutPageIndex;
